<ng-container [formGroup]="metadataFormGroup">
  <div class="row mb-2">
    <div class="col">
      <label i18n>Est</label>
      <select class="form-control" formControlName="residentStatus">
        <option *ngFor="let value of residentStatusValues" [ngValue]="value">
          {{ getResidentStatusLabel(value) }}
        </option>
      </select>
    </div>
  </div>
  <div class="row my-2">
    <div class="col">
      <label i18n>Type de couverture</label>
      <select class="form-control" formControlName="baseInsurance">
        <option *ngFor="let value of coverValues" [ngValue]="value">
          {{ getCoverLabel(value) }}
        </option>
      </select>
    </div>
  </div>
  <div *ngIf="showBuildingsForm()" class="w-100">
    <label class="mb-1" i18n>Nombre de bâtiment</label>
    <input
      class="form-control"
      [(ngModel)]="buildingNumberValue"
      type="number"
      min="0"
      max="5"
      [ngModelOptions]="{ standalone: true }"
    />

    <div class="mt-5" *ngIf="buildings && buildings.length > 0">
      <ng-container formArrayName="buildings">
        <ng-container *ngFor="let building of buildings.controls; index as i">
          <div class="mb-5" [formGroup]="getBuilding(i)">
            <div class="d-flex gap-3 my-3">
              <div class="flex-1 w-100">
                <label class="mb-1" i18n>Adresse du batiment {{ i + 1 }}</label>
                <input
                  type="text"
                  class="form-control"
                  formControlName="address"
                />
                <div
                  class="invalid"
                  *ngIf="getBuilding(i).errors?.['invalidAddress']"
                  i18n
                >
                  Adresse invalide ou numéro de rue manquant
                </div>
              </div>
              <div class="flex-1 w-100">
                <label class="mb-1" i18n
                  >NPA et ville du batiment {{ i + 1 }}</label
                >
                <input
                  class="form-control"
                  formControlName="postalCode"
                  name="postalCode"
                />
              </div>
              <div class="flex-1 w-100">
                <label class="mb-1" i18n
                  >Nombre d'appartements à assurer pour le bâtiment
                  {{ i + 1 }}</label
                >
                <input
                  min="0"
                  max="10"
                  class="form-control"
                  formControlName="appartmentCount"
                  type="number"
                  (ngModelChange)="onChangeAppartmentCount()"
                />
                <div
                  *ngIf="
                    getBuilding(i)?.controls?.['appartmentCount']?.invalid &&
                    (getBuilding(i)?.controls?.['appartmentCount']?.dirty ||
                      getBuilding(i)?.controls?.['appartmentCount']?.touched)
                  "
                  class="invalid"
                >
                  <div
                    *ngIf="
                      getBuilding(i)?.controls?.['appartmentCount']?.hasError(
                        'required'
                      )
                    "
                    i18n
                  >
                    Veuillez entrer un nombre
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </div>
  </div>
  <div class="row row-cols-md-2 row-cols-sm-1 my-2">
    <div class="col">
      <label>Nombre d'adultes</label>
      <input
        class="form-control"
        formControlName="adultsCount"
        type="number"
        min="0"
      />
    </div>
    <div class="col">
      <label>Nombre d'enfants</label>
      <input
        class="form-control"
        formControlName="childrenCount"
        type="number"
        min="0"
      />
    </div>
  </div>
  <div class="row">
    <div class="col">
      <label>Date de début d'assurance</label>
      <input
        class="form-control"
        [(ngModel)]="startDate"
        name="startDate"
        type="date"
        [ngModelOptions]="{ standalone: true }"
      />
    </div>
  </div>

  <div class="my-4">
    <div class="form-subtitle flex-basis-100 mb-16 text-16" i18n>Coassurés</div>
    <div class="row">
      <div class="col">
        <label i18n>Nombre de coassurés</label>
        <input
          type="number"
          min="0"
          class="form-control"
          [(ngModel)]="coInsuredCount"
          [ngModelOptions]="{ standalone: true }"
        />
      </div>
    </div>

    <ng-container formArrayName="coInsured">
      <ng-container
        *ngFor="
          let form of getFormArray(metadataFormGroup.controls['coInsured'])
            .controls;
          index as i
        "
      >
        <div
          class="my-3 d-flex gap-3"
          [formGroup]="getFormGroup(form)"
          id="form-{{ i }}"
        >
          <div class="flex-1 w-100">
            <label class="mb-2" for="lastName-{{ i }}" i18n>Nom</label>
            <input
              class="form-control"
              type="text"
              id="lastName-{{ i }}"
              formControlName="lastName"
            />
          </div>
          <div class="flex-1 w-100">
            <label class="mb-2" for="firstName-{{ i }}" i18n>Prénom</label>
            <input
              class="form-control"
              type="text"
              id="firstName-{{ i }}"
              formControlName="firstName"
            />
          </div>
          <div class="flex-1 w-100">
            <label class="mb-2" for="birthdate-{{ i }}" i18n
              >Date de naissance</label
            >
            <input
              id="birthdate-{{ i }}"
              type="date"
              class="form-control"
              formControlName="birthDate"
              name="dateDebut"
            />
          </div>
          <div class="flex-1 w-100">
            <label for="country-{{ i }}" class="mb-1" i18n>Nationalité</label>
            <select
              id="country-{{ i }}"
              class="form-control"
              name="country"
              formControlName="country"
            >
              <option
                *ngFor="let countryISO of countriesISO"
                [ngValue]="countryISO"
              >
                {{ countries[countryISO][languageCode] }}
              </option>
            </select>
          </div>
          <div class="flex-1 w-100">
            <label for="sex-{{ i }}" i18n>Sex</label>
            <select
              formControlName="gender"
              class="form-control"
              id="sex-{{ i }}"
            >
              <option [ngValue]="value" *ngFor="let value of sexOptions">
                {{ getSexEnumLabel(value) }}
              </option>
            </select>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </div>

  <div class="mt-4">
    <div class="form-subtitle flex-basis-100 mb-16 text-16" i18n>
      Questionnaire
    </div>
    <div class="row">
      <div class="col">
        <label i18n
          >A-t-il une protection juridique au cours des trois dernières années
          et le contrat a-t-il été résilié par la compagnie d'assurance ?</label
        >
        <div class="form-check">
          <input
            type="radio"
            name="alreadyClient"
            id="alreadyClientTrue"
            [value]="true"
            formControlName="alreadyClient"
          />
          <label class="form-check-label" for="alreadyClientTrue" i18n>
            Oui
          </label>
        </div>
        <div class="form-check">
          <input
            type="radio"
            name="alreadyClient"
            id="alreadyClientFalse"
            [value]="false"
            formControlName="alreadyClient"
          />
          <label class="form-check-label" for="alreadyClientFalse" i18n>
            Non
          </label>
        </div>
      </div>
    </div>
    <div *ngIf="metadataFormGroup.value.alreadyClient">
      <div class="my-2">
        <label class="mb-2" for="risk" i18n>Pour quels risques ?</label>
        <input
          class="form-control"
          type="text"
          name="risk"
          formControlName="risk"
        />
      </div>
      <div class="my-2">
        <label class="mb-2" for="company" i18n
          >Compagnie/numéro de police</label
        >
        <input
          class="form-control"
          type="text"
          name="company"
          formControlName="company"
        />
      </div>
      <div class="my-2">
        <label class="mb-2" for="resiliation" i18n
          >Raison de la résiliation</label
        >
        <input
          class="form-control"
          type="text"
          name="resiliation"
          formControlName="resiliation"
        />
      </div>
    </div>

    <div class="row">
      <div class="col">
        <label i18n
          >Une personne à assurer est-elle actuellement impliquée dans un litige
          ou l'a-t-elle été au cours des trois dernières années ou sait-il
          qu'une personne à assurer le sera bientôt ?</label
        >
        <div class="form-check">
          <input
            type="radio"
            name="userInLitigation"
            id="userInLitigationTrue"
            [value]="true"
            formControlName="userInLitigation"
          />
          <label class="form-check-label" for="userInLitigationTrue" i18n>
            Oui
          </label>
        </div>
        <div class="form-check">
          <input
            type="radio"
            name="userInLitigation"
            id="userInLitigationFalse"
            [value]="false"
            formControlName="userInLitigation"
          />
          <label class="form-check-label" for="userInLitigationFalse" i18n>
            Non
          </label>
        </div>
      </div>
    </div>
  </div>
</ng-container>
